
import {Component, Input} from '@angular/core';


@Component({
  selector: 'cascading-dropdown-type',
  templateUrl: './cascading-dropdown-type.component.html',
  styleUrls: ['./cascading-dropdown-type.component.css']
})
export class CascadingDropdownTypeComponent {



}



// WEBPACK FOOTER //
// ./src/app/oldCentralPannel/cascading-dropdown-type/cascading-dropdown-type.component.ts